import { SectionIndexItem } from '../components/SectionIndexAutocomplete';

function makeItems(
  tabKey: string,
  tabLabel: string,
  sectionLabel: string,
  sectionId: string,
  labels: string[]
): SectionIndexItem[] {
  return labels.map((label) => ({
    label,
    sectionLabel,
    sectionId,
    tabKey,
    tabLabel,
  }));
}

export const apartmentSectionIndex: SectionIndexItem[] = [
  // region — Características e Região
  ...makeItems(
    'region',
    'Características e Região',
    'Usos Predominantes',
    'region-usos-predominantes',
    ['Usos Predominantes']
  ),
  ...makeItems(
    'region',
    'Características e Região',
    'Infraestrutura Urbana',
    'region-infraestrutura-urbana',
    ['Infraestrutura Urbana']
  ),
  ...makeItems(
    'region',
    'Características e Região',
    'Serviços Públicos e Comunitários',
    'region-servicos-publicos',
    ['Serviços Públicos e Comunitários']
  ),
  ...makeItems(
    'region',
    'Características e Região',
    'Padrão das Edificações na Região',
    'region-padrao-edificacoes',
    ['Padrão das Edificações na Região']
  ),
  ...makeItems(
    'region',
    'Características e Região',
    'Influências',
    'region-influencias',
    ['Influências', 'Valorizantes', 'Desvalorizantes']
  ),
  ...makeItems(
    'region',
    'Características e Região',
    'Outras características',
    'region-outras-caracteristicas',
    [
      'Outras características',
      'Via de Acesso',
      'Descreva a Via de Acesso',
      'Região',
    ]
  ),

  // evaluating_unit — Unidade Avaliando
  ...makeItems(
    'evaluating_unit',
    'Unidade Avaliando',
    'Vistoria',
    'evaluating-unit-vistoria',
    ['Vistoria', 'Data da Vistoria']
  ),
  ...makeItems(
    'evaluating_unit',
    'Unidade Avaliando',
    'Características Gerais',
    'evaluating-unit-caracteristicas-gerais',
    [
      'Características Gerais',
      'Andar',
      'Qtd. de Pavimentos na Unidade',
      'N° da Unidade no Andar',
      'Unidade Cobertura',
      'Estado de Conservação',
      'Padrão de Acabamento',
      'Destinação',
      'Ocupação',
      'Paredes Internas',
    ]
  ),
  ...makeItems(
    'evaluating_unit',
    'Unidade Avaliando',
    'Posição da Unidade',
    'evaluating-unit-posicao-unidade',
    ['Posição da Unidade', 'Posição Física', 'Orientação Solar', 'Vista']
  ),
  ...makeItems(
    'evaluating_unit',
    'Unidade Avaliando',
    'Vagas de Garagem',
    'evaluating-unit-vagas-garagem',
    [
      'Vagas de Garagem',
      'Cobertas Livres/Independentes',
      'Cobertas Bloqueadas/Bloqueantes',
      'Descobertas Livres/Independentes',
      'Descobertas Bloqueadas/Bloqueantes',
      'Total de Vagas',
    ]
  ),

  // frames_and_facades — Esquadrias e Fachadas
  ...makeItems(
    'frames_and_facades',
    'Esquadrias e Fachadas',
    'Fachada Principal',
    'frames-fachada-principal',
    ['Fachada Principal', 'Esquadrias', 'Revestimento']
  ),
  ...makeItems(
    'frames_and_facades',
    'Esquadrias e Fachadas',
    'Demais Fachadas',
    'frames-demais-fachadas',
    ['Demais Fachadas']
  ),

  // wet_and_dry_areas — Áreas Molhadas e Secas
  ...makeItems(
    'wet_and_dry_areas',
    'Áreas Molhadas e Secas',
    'Áreas Molhadas',
    'wet-dry-areas-molhadas',
    ['Áreas Molhadas', 'Pisos', 'Paredes']
  ),
  ...makeItems(
    'wet_and_dry_areas',
    'Áreas Molhadas e Secas',
    'Áreas Secas',
    'wet-dry-areas-secas',
    ['Áreas Secas']
  ),

  // construction_areas — Áreas de Construção
  ...makeItems(
    'construction_areas',
    'Áreas de Construção',
    'Áreas de Construção',
    'construction-areas-construcao',
    [
      'Áreas de Construção',
      'Privativa da Unidade',
      'Privativa Descontínua',
      'Áreas Comuns',
      'Total Averbada',
      'Total Não Averbada',
    ]
  ),
  ...makeItems(
    'construction_areas',
    'Áreas de Construção',
    'Privativa Descobertas',
    'construction-privativa-descobertas',
    ['Privativa Descobertas', 'Área']
  ),
  ...makeItems(
    'construction_areas',
    'Áreas de Construção',
    'Divisão Interna',
    'construction-divisao-interna',
    [
      'Divisão Interna',
      'Áreas Sociais',
      'Sala(s)',
      'Hall(s)/Circulação(ões)',
      'Sacada(s)/Varanda(s)',
      'Terraço(s)',
      'Mezanino(s)',
      'Escritório/Gabinete',
      'Áreas íntimas',
      'Quarto(s)',
      'Quarto(s) de Empregada',
      'Closet(s)',
      'Cozinha e Serviços',
      'Cozinha(s)',
      'Cozinha Americana',
      'Copa(s)',
      'Copa/Cozinha Conjugadas',
      'Cozinha/Área de Serviço Conjugadas',
      'Área(s) de Serviço',
      'Área(s) de Serviço Descobertas',
      'Despensa(s)/Depósito(s)',
      'Banheiros',
      'Banheiro(s) Sociai(s)',
      'Banheiro(s) Privativo(s)',
      'Banheiro(s) de Serviço',
      'Banheiro Privativo de Empregada',
      'Lavabo(s)',
    ]
  ),

  // building — Prédio
  ...makeItems(
    'building',
    'Prédio',
    'Dados do Prédio',
    'building-dados-predio',
    [
      'Dados do Prédio',
      'Implantação',
      'Número de Pavimentos',
      'Número de Unidades',
      'Número de Subsolos',
      'Número de Elevadores',
    ]
  ),
  ...makeItems(
    'building',
    'Prédio',
    'Caracterização da Cobertura',
    'building-caracterizacao-cobertura',
    ['Caracterização da Cobertura']
  ),
  ...makeItems('building', 'Prédio', 'Conservação', 'building-conservacao', [
    'Conservação',
    'Idade Estimada',
    'Estado de Conservação',
    'Destinação',
  ]),
  ...makeItems(
    'building',
    'Prédio',
    'Ocupação de Térreo',
    'building-ocupacao-terreo',
    ['Ocupação de Térreo']
  ),
  ...makeItems(
    'building',
    'Prédio',
    'Características Gerais',
    'building-caracteristicas-gerais',
    ['Características Gerais', 'Padrão de Acabamento', 'Pisos', 'Paredes']
  ),

  // enterprise — Empreendimento
  ...makeItems(
    'enterprise',
    'Empreendimento',
    'Dados Gerais',
    'enterprise-dados-gerais',
    [
      'Dados Gerais',
      'Padrão do Empreendimento',
      'Estado de Conservação',
      'Controle de Acesso',
      'N° de Prédios',
      'N° Total de Unidades',
      'N° de Unidade de Tipologia',
      'Fração Ideal',
    ]
  ),
  ...makeItems(
    'enterprise',
    'Empreendimento',
    'Terreno',
    'enterprise-terreno',
    [
      'Terreno',
      'Posição',
      'Cota/Greide',
      'Área (m²)',
      'Testada',
      'Profundidade equivalente (m)',
      'Cercamento',
      'Tipo de Cercamento Frente',
      'Tipo de Cercamento Lateral/Fundos',
    ]
  ),
  ...makeItems(
    'enterprise',
    'Empreendimento',
    'Usos e Infraestrutura',
    'enterprise-usos-infraestrutura',
    ['Usos e Infraestrutura', 'Ocupação do Terreno', 'Infraestrutura']
  ),
  ...makeItems(
    'enterprise',
    'Empreendimento',
    'Equipamentos',
    'enterprise-equipamentos',
    ['Equipamentos', 'N° Armários Embutidos', 'N° Salas de Lazer']
  ),
  ...makeItems(
    'enterprise',
    'Empreendimento',
    'Dados Administrativos',
    'enterprise-dados-administrativos',
    [
      'Dados Administrativos',
      'Taxa de Condomínio',
      'Administradora do Condomínio',
      'Telefone Administradora',
      'Email Administradora',
    ]
  ),
];
